var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-partners__item" }, [
    _c(
      "div",
      {
        staticClass: "page-partners__partners-info",
        class: _vm.isActive(_vm.partner.id) ? "active-partner" : "",
        on: {
          click: function ($event) {
            return _vm.onChangePartner()
          },
        },
      },
      [
        _vm.partner.logo
          ? _c("div", [
              _c("img", {
                staticClass: "page-partners__partners-img",
                attrs: { src: _vm.partner.logo, alt: "logo" },
              }),
            ])
          : _c("div", [
              _c("p", { staticClass: "page-partners__partners-logo-text" }, [
                _vm._v("\n        " + _vm._s(_vm.partner.name) + "\n      "),
              ]),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }